import {AxiosResponse} from "axios";
import EventRequest from "../domain/endpoint/EventRequest";
import Poller from "../domain/poller/Poller";
import PollerPayload from "../domain/poller/PollerPayload";
import axios from "./axios";
import PollControllerBase from "./PollControllerBase";

export default class EventController extends PollControllerBase {
    public static sendEvent(eventRequest: EventRequest ) {
        // allow 2 retries since all links are opened with new window
        const payload = new PollerPayload((currentAttempt: number) => {
            return new Promise((resolve, reject) => {
                eventRequest.attempt = currentAttempt;
                axios.post("/event", eventRequest)
                    .then((data: AxiosResponse) => {
                        resolve(data.data);
                    })
                    .catch((err: any) => {
                        reject(err);
                    });
            });
        }, this.validator, 1000, 2, null);
        return (new Poller(payload)).execute();

    }

}
